import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { VehicleType } from '@app/entities/enums/ptrab/vehicle-type.enum';
import { LicensePlateRequest, LicensePlates } from '@app/entities/models/ptrab/license-plates/license-plates.model';

export interface LicensePlatesUseCases {
  getLicensePlates(): Observable<LicensePlates>;
  createLicensePlate(licensePlate: LicensePlateRequest, vehicleType: VehicleType): Observable<object>;
  updateLicensePlate(
    licensePlate: LicensePlateRequest,
    vehicleType: VehicleType,
    vehicleId: string
  ): Observable<object>;
  deleteLicensePlate(vehicleType: VehicleType, vehicleId: string): Observable<object>;
}

export const LICENSE_PLATES_USE_CASES = new InjectionToken<LicensePlatesUseCases>('LICENSE_PLATES_USE_CASES');
